export default __webpack_public_path__ + "static/media/Dive6.3e953a6f.png";